import { CloseEditorIfOpenedEvent } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/BuilderController';
import { ExecuteScriptV2ActionSettings } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/ExecuteScriptV2ActionSettings';
import { DEFAULT_VARIABLES_NAMES } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/services/BuilderService';
import { ActionController, ACTION_UNDO_REDO_CHANGES } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/ActionController';
import { BuilderFeatures } from '../../../BuilderFeatures';
import { ActionFeatures } from '../ActionFeatures';
import { VARIABLE_VALIDATION_REGEX } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/Validator';
import '../Actions.scss';
export class ExecuteScriptV2ActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', 'SidebarContentService', '$translate', 'PipelineCodeEditorService', '$rootScope', 'UndoRedoService', 'state', '$timeout', 'CurrentApplicationService', '$scope', 'typeOfAction', 'onOpenSchemaEditor', 'onActionBlur'];
    constructor(close, action, $onStateChanged, SidebarContentService, $translate, PipelineCodeEditorService, $rootScope, UndoRedoService, state, $timeout, CurrentApplicationService, $scope, typeOfAction, onOpenSchemaEditor, onActionBlur) {
        super(close, action, $onStateChanged, UndoRedoService, state, $rootScope, $scope, typeOfAction, onOpenSchemaEditor, onActionBlur);
        this.SidebarContentService = SidebarContentService;
        this.$translate = $translate;
        this.PipelineCodeEditorService = PipelineCodeEditorService;
        this.$rootScope = $rootScope;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.$timeout = $timeout;
        this.CurrentApplicationService = CurrentApplicationService;
        this.updateInputVariables = (event) => {
            const { detail: { data } } = event;
            this.action.settings.inputVariables = data;
            this.handleSaveAction();
        };
        this.onContinueToggle = async (event) => {
            const continueOnError = event.detail.checked;
            this.action.continueOnError = continueOnError;
            this.handleSaveAction();
        };
        this.variables = DEFAULT_VARIABLES_NAMES.map(label => ({ label, value: label }));
        this.isEditorOpened = false;
        // this.handleReturnAutoSave = debounce(this.handleSaveAction, 800);
        this.init();
    }
    async init() {
        // this.$scope.$watch('$ctrl.action.settings.outputVariable', (oldValue, newValue) => {
        //     this.$timeout(this.handleSaveAction.bind(this));
        // });
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
        this.initializeListeners();
        this.updateActionInputVariables();
        this.application = await this.CurrentApplicationService.fetchApplicationByStateParams();
        this.isActionConditionEnabled = await ActionFeatures.isActionConditionEnabled();
    }
    async initializeListeners() {
        const isBuilderUndoRedoActionEnabled = await BuilderFeatures.builderUndoRedoActionEnabled();
        if (isBuilderUndoRedoActionEnabled) {
            this.$rootScope.$on(ACTION_UNDO_REDO_CHANGES, () => this.updateActionInputVariables());
        }
    }
    updateActionInputVariables() {
        this.inputVariables = this.action.settings.inputVariables;
    }
    create() {
        return new ExecuteScriptV2ActionSettings();
    }
    validateOutputVariable() {
        const isValid = this.checkRegexVariable();
        this.returnValueForm.returnValue.$invalid = isValid;
        this.returnValueForm.returnValue.$valid = !isValid;
        this.returnValueForm.returnValue.$setDirty();
    }
    handleSaveAction() {
        this.validateOutputVariable();
        // Todo: change the handleReturnAutoSave to not call here multiple times
        this.onActionBlur(this.action);
        this.save();
    }
    checkRegexVariable() {
        return this.action.settings.outputVariable
            && !this.action.settings.outputVariable.match(VARIABLE_VALIDATION_REGEX);
    }
    toggleCodeEditor() {
        switch (this.isEditorOpened) {
            case true:
                this.closeCodeEditor();
                this.isEditorOpened = false;
                break;
            case false:
                this.openCodeEditor();
                this.isEditorOpened = true;
                break;
        }
    }
    async openCodeEditor() {
        this.sidebarEditor = await this.PipelineCodeEditorService.openCodeEditor({
            code: this.action.settings.source,
            language: 'javascript',
            editorWasCreated: this.editorWasCreated.bind(this),
            SidebarContentService: this.SidebarContentService,
            onCodeEditorChange: ({ code }) => {
                this.action.settings.source = code;
            },
            onSaveSource: () => {
                if (this.containsBlipFunctionKey(this.action.settings.source)) {
                    this.trackBlockActionLibraryCalledScript();
                }
                this.handleSaveAction();
            },
        });
        const deregisterCloseEditorEvent = this.$rootScope.$on(CloseEditorIfOpenedEvent, () => {
            this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        });
        await this.sidebarEditor.closeDeferred.promise; // when code editor close
        deregisterCloseEditorEvent();
        this.isEditorOpened = false;
    }
    containsBlipFunctionKey(input) {
        const pattern1 = 'blipfunction';
        const pattern2 = 'blipFunction';
        return input.includes(pattern1) || input.includes(pattern2);
    }
    closeCodeEditor() {
        this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        this.sidebarEditor = undefined;
    }
    /**
     * Callback executed after code editor created
     * @param object - Code editor standalone
     */
    editorWasCreated({ editor }) {
        this.isMonacoLoading = false;
        setTimeout(() => {
            editor.layout();
        }, 500);
    }
    onInputTitleBlur() {
        this.isEditing = false;
        if (this.action.$title.length === 0) {
            this.action.$title = this.$translate.instant('builder-tabs-actions.executeScriptV2.title');
        }
        this.handleSaveAction();
    }
    startEditingInputTitle() {
        const input = document.getElementById('execute-script-v2-title');
        if (input) {
            input.focus();
        }
    }
    trackBlockActionLibraryCalledScript() {
        this.BuilderSegmentService.trackBlockActionLibraryCalledScript({}, true);
    }
}
ExecuteScriptV2ActionController.$inject = ['close', 'action', '$onStateChanged', 'SidebarContentService', '$translate', 'PipelineCodeEditorService', '$rootScope', 'UndoRedoService', 'state', '$timeout', 'CurrentApplicationService', '$scope', 'typeOfAction', 'onOpenSchemaEditor', 'onActionBlur'];
